import React from "react";
import { FieldTypeIcon } from "../../atoms/FieldTypeIcon";
import { TagChip } from "../../atoms/TagChip";
import { Header, TagRow, Title, TitleRow } from "./FieldDetailCardHeader.styles";
import type { FieldDetailCardHeaderProps } from "./FieldDetailCardHeader.types";

/** Field hover card header — type glyph + field name, then the type/role tags. */
export const FieldDetailCardHeader: React.FC<FieldDetailCardHeaderProps> = ({
  label,
  kind,
  chips,
  titleId,
  testId,
  className,
}) => (
  <Header data-testid={testId} className={className}>
    <TitleRow>
      <FieldTypeIcon kind={kind} />
      <Title id={titleId} title={label}>
        {label}
      </Title>
    </TitleRow>
    {chips.length > 0 ? (
      <TagRow>
        {chips.map((chip) => (
          <TagChip key={chip} label={chip} />
        ))}
      </TagRow>
    ) : null}
  </Header>
);

export default FieldDetailCardHeader;
